import { buildCrmProjectId } from "./registrationEventCampaign";
import { resolveRegistrationStakeholderType } from "./roleMap";
import { DEFAULT_REGISTRATION_COUNTRY } from "./crmPayload";
import type { RegistrationExpressValues } from "./expressSchema";

/** Body for express `POST /api/buxus/account-setup-crm` (legacy `ExpressRegistrationForm`). */
export function buildExpressAccountSetupCrmPayload(input: {
  abpUserId: string;
  values: RegistrationExpressValues;
  quickCode?: string;
  approvalCode?: string | null;
  eventCodeSlug?: string | null;
}): Record<string, unknown> {
  const { abpUserId, values, quickCode, approvalCode, eventCodeSlug } = input;
  const email = values.email.trim();
  const phone = values.phone.trim();
  const jobTitle = values.jobTitle.trim();
  const stakeholderType = resolveRegistrationStakeholderType(
    values.stakeholderType,
    jobTitle,
    values.isUnaffiliatedProfessionalErTrainer,
  );
  const qc = (quickCode ?? "").trim();
  const state = values.state.trim();
  const county = values.county.trim();

  return {
    abpUserId,
    first_Name: values.firstName.trim(),
    last_Name: values.lastName.trim(),
    email,
    phone,
    tenant_Email: email,
    tenant_Phone: phone,
    stakeholder_Type: stakeholderType,
    job_Title: jobTitle || undefined,
    title: jobTitle || undefined,
    is_Unaffiliated_Professional_ER_Trainer:
      values.isUnaffiliatedProfessionalErTrainer.trim() || undefined,
    communications_Role: values.communicationsRole.trim() || undefined,
    project_ID_2: buildCrmProjectId(eventCodeSlug ?? undefined),
    quick_Code_Computed: qc.length > 4 ? qc : undefined,
    approval_Code: approvalCode?.trim() || undefined,
    situs_Country: DEFAULT_REGISTRATION_COUNTRY,
    situs_State: state,
    situs_County: county,
    jurisdictions: [
      {
        country: DEFAULT_REGISTRATION_COUNTRY,
        state,
        county,
      },
    ],
    email_Opt_Out: false,
  };
}
